import { createAction, props } from '@ngrx/store';
import { Update, EntityMap, EntityMapOne } from '@ngrx/entity';
import { IDjangoPaginationData } from '@shared/ui-components/au-paginator/pagination-page.info';
import {
	IRequest,
	IRequestPayload,
	IRequestCreateVariables,
	ICmmsRequestsQueryVariables,
} from '@app/pages/cmms/interfaces/request.interfaces';
import { AuGqlError } from '@app/shared';
import { ICMMSColumn } from '@shared/ui-components/au-table-layout/utils/interfaces';

export const loadDefaultRequests = createAction(
	'[REQUESTS] Load requests with default variables'
);

export const startLoadingRequests = createAction(
	'[REQUESTS] Start loading requests',
	props<{ variables: ICmmsRequestsQueryVariables }>()
);

export const requestsFailedToLoad = createAction('[REQUESTS] Requests failed to load');

export const requestsLoaded = createAction(
	'[REQUESTS] Requests loaded',
	props<{
		requestPagination: IDjangoPaginationData;
		requests: IRequest[];
	}>()
);

export const storeRequestsQueryVariables = createAction(
	'[REQUESTS] Store requests query variables',
	props<{ variables: ICmmsRequestsQueryVariables }>()
);

export const dropRequestsQueryVariables = createAction(
	'[REQUESTS] Drop requests query variables'
);

export const setRequestForEditing = createAction(
	'[REQUESTS] Add request for editing',
	props<{
		requestEdit: IRequest;
	}>()
);

export const startEditRequest = createAction(
	'[REQUESTS] Start edit request',
	props<{
		request: Partial<IRequestPayload>;
	}>()
);

export const editRequestSuccess = createAction(
	'[REQUESTS] Edit request success',
	props<{
		request: IRequest;
	}>()
);

export const setRequests = createAction(
	'[REQUESTS] Set requests',
	props<{ requests: IRequest[] }>()
);
export const startCreateRequest = createAction(
	'[REQUESTS] Start create request',
	props<{
		variables: IRequestCreateVariables;
		skipTableReload?: boolean;
		closeSidebar: boolean;
	}>()
);
export const createRequestSuccess = createAction(
	'[REQUESTS] Create requests success',
	props<{ request: IRequest; skipTableReload?: boolean }>()
);
export const createRequestError = createAction(
	'[REQUESTS] Create requests error',
	props<{ error?: AuGqlError }>()
);
export const addRequest = createAction(
	'[REQUESTS] Add request',
	props<{ request: IRequest }>()
);
export const setRequest = createAction(
	'[REQUESTS] Set request',
	props<{ request: IRequest }>()
);
export const upsertRequest = createAction(
	'[REQUESTS] Upsert request',
	props<{ request: IRequest }>()
);
export const addRequests = createAction(
	'[REQUESTS] Add requests',
	props<{ requests: IRequest[] }>()
);
export const upsertRequests = createAction(
	'[REQUESTS] Upsert requests',
	props<{ requests: IRequest[] }>()
);
export const updateRequest = createAction(
	'[REQUESTS] Update request',
	props<{ update: Update<IRequest> }>()
);
export const updateRequests = createAction(
	'[REQUESTS] Update requests',
	props<{ updates: Update<IRequest>[] }>()
);
export const updateRequestSuccess = createAction(
	'[REQUESTS] Update request success',
	props<{ workOrder: IRequest }>()
);
export const mapRequest = createAction(
	'[REQUESTS] Map request',
	props<{ entityMap: EntityMapOne<IRequest> }>()
);
export const mapRequests = createAction(
	'[REQUESTS] Map requests',
	props<{ entityMap: EntityMap<IRequest> }>()
);
export const startDeletingRequest = createAction(
	'[REQUESTS] Start deleting request',
	props<{ pk: string }>()
);
export const deletingRequestSuccess = createAction(
	'[REQUESTS] Deleting request success',
	props<{ pk: string }>()
);
export const deleteRequest = createAction(
	'[REQUESTS] Delete request',
	props<{ pk: string }>()
);
export const deleteRequests = createAction(
	'[REQUESTS] Delete requests',
	props<{ pks: string[] }>()
);

export const openNewRequestFromOutside = createAction(
	'[REQUESTS] Open new request workspace from outside',
	(requestData = null) => ({ requestData })
);

export const openRequestWorkspaceFromOutside = createAction(
	'[REQUESTS] Open request workspace from outside',
	props<{ pk: string }>()
);

export const setRequestsTableConfig = createAction(
	'[REQUESTS] Set request table config',
	props<{
		isExportable: boolean;
		columns: ICMMSColumn[];
	}>()
);

export const addRequestExternalData = createAction(
	'[REQUESTS] Add request external data',
	(requestData = null) => ({ requestData })
);

export const clearRequestExternalData = createAction(
	'[REQUESTS] Clear request external data'
);
